import * as React from 'react';
import { connect } from 'react-redux';

import { TRadioChangedAction } from '../../../../../common/state/actions';
import { IAppState, Dispatch } from '../../../../../common/state/app_state';
import { IJsonQueryBooleanParams } from '../../../../../json_query';
import { Row } from '../../markup';
import { ButtonRadioGroupParamView, IButtonRadioGroupParamViewProps } from './views/button_radio_group_param';

export interface IBooleanParamProps extends IButtonRadioGroupParamViewProps {
  title: string;
}

export type TStateProps = Pick<IBooleanParamProps, 'value'>;
export type TDispatchProps = Pick<IBooleanParamProps, 'onValueChange'>;
export type TOwnProps = Pick<IBooleanParamProps, 'titleComment'>;

const BooleanParam: React.StatelessComponent<IBooleanParamProps> = props => (
  <Row
    title={
      <span>
        {props.title}
        <br />
        {props.titleComment || ''}
      </span>
    }
  >
    <ButtonRadioGroupParamView
      trueValue={props.trueValue}
      falseValue={props.falseValue}
      value={props.value}
      onValueChange={props.onValueChange}
    />
  </Row>
);

export const getBooleanParam = (
  title: string,
  trueValue: string,
  falseValue: string,
  jsonQueryParamName: keyof IJsonQueryBooleanParams,
  changeHandler: (value: boolean | undefined) => TRadioChangedAction,
) => {
  return connect<TStateProps, TDispatchProps, TOwnProps, IBooleanParamProps, IAppState>(
    (state: IAppState) => ({
      value:
        state.filters.jsonQuery[jsonQueryParamName] &&
        // tslint:disable-next-line:no-any
        (state.filters.jsonQuery[jsonQueryParamName] as any).value,
    }),
    (dispatch: Dispatch) => ({
      onValueChange: (value: boolean | undefined): void => {
        dispatch(changeHandler(value));
      },
    }),
    (stateProps, dispatchProps, ownProps) => ({
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      title,
      trueValue,
      falseValue,
    }),
  )(BooleanParam);
};
